import React, {Dispatch, SetStateAction, Suspense, useEffect, useState} from 'react';
import {Loader} from "../Loader/Loader";
import s from "./Form2FaSettings.module.css";
import styles from '../../styles/styles.module.css';
import MyInput from "../ui/MyInput/MyInput";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import MyBtn from "../ui/MyBtn/MyBtn";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {useFormik} from "formik";
import {send2FaThunk, SetNew2FaStatus, setTokenState} from "../../store/reducers/ActionCreators";
import CustomModal from "../ui/CustomModal/CustomModal";
import {ReactComponent as Back} from '../../assets/img/personalAccount/back.svg'
import iconCheck from '../../assets/img/personalAccount/tick-circle.svg'
import close_circle from '../../assets/img/personalAccount/close-circle.svg'
import * as yup from "yup";

type PropsType = {
    qrData: {
        code: string;
        qr: string;
    };
    setQrData: any;
    setIs2faSettingsOpen: Dispatch<SetStateAction<boolean>>
}

const Form2FaSettings = (props: PropsType) => {
   
    const {isLoading} = useAppSelector(store => store.userReducer)
    const token = useAppSelector(state => state.userReducer.userToken)

    const dispatch = useAppDispatch()
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean | null>(false)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean | null>(false)
    const [errorMessage, setErrorMessage] = useState("")

    const [isShowLoadingProcess, setIsShowLoadingProcess] = useState(isLoading)

    const [isImageLoaded, setIsImageLoaded] = useState(false);

   
    useEffect(() => {
        if (props.qrData.qr === '' && props.qrData.code === '') {
            setIsShowLoadingProcess(true);
        } else {
            setIsShowLoadingProcess(false)
        }
    }, [props.qrData.qr, props.qrData.code]);

    const handleImageLoad = () => {
        setIsImageLoaded(true);
    };

    useEffect(() => {
        if (props.qrData.qr) { 
            const img = new Image(); 
            img.src = props.qrData.qr; 

            img.onload = () => {
                
                setIsImageLoaded(true);
            };

            img.onerror = () => {
                // Если произошла ошибка загрузки, можно обработать её здесь
                console.error('Image failed to load');
                setIsImageLoaded(false); // Или установить состояние загрузки в false
            };
        }
    }, [props.qrData.qr]);

    const validationSchema = yup.object({
        code: yup.string()
            .required("Required field")
            .matches(/^[0-9/,]+$/, "Must be only digits")
    })

    const send2FaFormik = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema: validationSchema,
        onSubmit: async values => { 
            dispatch(send2FaThunk(token, values))
                .then((res) => {
                    setIsSuccessModalOpen(true)
                    dispatch(SetNew2FaStatus())
                })
                .catch((rej) => {
                    // "Invalid authorization data"
                    if (rej.response.data === "Error: Conflict") {
                        dispatch(setTokenState(false))
                    }

                    if (rej.response.data === "Invalid code") {
                        setErrorMessage("Invalid code")
                    }

                    setIsErrorModalOpen(true)
                })
        }
    })

    const closeModal = () => {
        setIsSuccessModalOpen(false)
        props.setIs2faSettingsOpen(false)
    }

    

    
    return (
        <div>
            <CustomModal type={"confirm"} setIsModalOpen={setIsSuccessModalOpen} isModalOpen={isSuccessModalOpen}>
                <div className={s.modal_content}>
                    <div>
                        <img src={iconCheck} alt=""/>
                    </div>
                    <div className={s.modal_title}>
                        Success!
                    </div>
                    <div className={s.subtitle}>
                        Google Authenticator (2FA) has been enabled.
                    </div>
                    <div className={s.btn_block}>
                        <div className={s.btn_wrapper}>
                            <MyBtn isPersonalAccountBtn title={"Ok"} onClick={() => closeModal()}/>
                        </div>
                    </div>
                </div>

            </CustomModal>
            <CustomModal type="error" isModalOpen={isErrorModalOpen} setIsModalOpen={setIsErrorModalOpen}>
                <div className={styles.modal_content}>
                    <img src={close_circle} alt=""/>
                    <div className={styles.popup_title}>
                        Oops!
                    </div>
                    <div className={styles.popup_subtitle}>
                        {errorMessage}
                    </div>
                    <div className={styles.popup_button_block}>
                        <div className={styles.buttonWrapper}>
                            <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                setIsErrorModalOpen(false)
                            }}/>
                        </div>
                    </div>
                </div>
            </CustomModal>

            <form onSubmit={send2FaFormik.handleSubmit}>
                {
                    isShowLoadingProcess
                        ? <Loader/>
                        : <div className={s.wrapper}>
                            <div className={s.autentication_list_block}>
                                <div className={s.title}>
                                    Set up 2FA
                                </div>
                                <div className={s.settings_desc}>
                                    <div>
                                        <div className={s.desc_item}>
                                            <span><b>1.</b> Get the Google Authenticator App from the <b>Google Play/App Store.</b></span>
                                        </div>
                                        <div className={s.desc_item}>
                                            <span><b>2.</b> In the App select <b>Set up account.</b></span>
                                        </div>
                                        <div className={s.desc_item}>
                                            <span><b>3.</b> Choose <b>Scan barcode.</b></span>
                                        </div>
                                    </div>
                                </div>
                                {
                                isImageLoaded ? 
                                <div className={s.qr_block}>
                                
                                    <img onLoad={handleImageLoad} src={props.qrData.qr} className={s.qr_image} alt="" />
                                    <div className={s.input_wrapper}>
                                        <span className={s.input_label}>Code</span>
                                        <div className={s.input_wrapper}>
                                            <MyInput value={props.qrData.code}
                                                     onChange={() => {
                                                     }}
                                            />
                                        </div>
                                </div> 
                                </div>
                                 : <Loader/>}
                                
                                    
                                <div className={s.input_block}>
                                    <div className={s.title}>
                                        Enable two-factor authentication
                                    </div>
                                    <div className={s.mobile_width}>
                                        <span className={s.input_label}>code from Google Authenticator</span>
                                        <div className={s.input_wrapper}>
                                            <MyInput
                                                id="code"
                                                name="code"
                                                value={send2FaFormik.values.code}
                                                placeholder={"6 digits"}
                                                onChange={send2FaFormik.handleChange}
                                                isError={send2FaFormik.errors.code}
                                                touched={send2FaFormik.touched}
                                            />
                                            {send2FaFormik.errors.code &&
                                                <span className={s.error}>
                                                        {send2FaFormik.errors.code}
                                                    </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={s.buttons_block}>
                                    <div className={s.button_wrapper}>
                                        <TransparentButton title={'Back'}
                                                           isPersonalAccountBtn
                                                           large
                                                           style={{width: '100%'}}
                                                           icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                                           onClick={() => props.setIs2faSettingsOpen(false)}/>
                                    </div>
                                    <div className={s.button_wrapper}>
                                        <MyBtn title={'Enable'} large type="submit" isPersonalAccountBtn/>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </form>
        </div>
    );
};

export default Form2FaSettings;
